export const makeUrl = (pageName: string, pageParam?: string): string =>
  pageParam ? `/${pageName}/${pageParam}` : `/${pageName}`;

export const openUrlInNewTab = (url: string): void => {
  if (typeof window !== 'undefined') {
    window.open(url, '_blank');
  }
};
